// extracted by mini-css-extract-plugin
export default {"Breadcrumbs":"TumJdyUJ","BreadcrumbItem":"WRWeWs10","BreadcrumbItemSeparator":"Xw72UkXf"};